export default __webpack_public_path__ + "static/media/ic-twitter.8b21fa16.svg";